import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  iniciarConversacionService,
  getSesionActualService,
  getConfiguracionesService,
  responderService,
  responderConMediaService,
  adjuntarMediaService,
  eliminarMediaService,
  completarSesionService,
  getMisSesionesService,
  getResumenService,
} from "../../services/conversacion/conversacion.service";

/* ── Helper: algunos endpoints devuelven { message, data: {...}, status_code }
      y otros devuelven el objeto directo. Esto normaliza ambos casos. ── */
const unwrap = (payload) => payload?.data ?? payload;

// ── Iniciar sesión ──────────────────────────────────
export const iniciarConversacionThunk = createAsyncThunk(
  "conversacion/iniciar",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await iniciarConversacionService(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al iniciar la conversación",
      );
    }
  },
);

// ── Sesión actual ───────────────────────────────────
export const getSesionActualThunk = createAsyncThunk(
  "conversacion/sesionActual",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSesionActualService();
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener la sesión activa",
      );
    }
  },
);

// ── Configuraciones ─────────────────────────────────
export const getConfiguracionesThunk = createAsyncThunk(
  "conversacion/configuraciones",
  async (sesionId, { rejectWithValue }) => {
    try {
      const response = await getConfiguracionesService(sesionId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Error al cargar las configuraciones",
      );
    }
  },
);

// ── Responder (texto) ───────────────────────────────
export const responderThunk = createAsyncThunk(
  "conversacion/responder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await responderService(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al guardar la respuesta",
      );
    }
  },
);

// ── Responder con media ─────────────────────────────
export const responderConMediaThunk = createAsyncThunk(
  "conversacion/responderConMedia",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await responderConMediaService(formData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Error al guardar la respuesta con archivos",
      );
    }
  },
);

// ── Adjuntar media ──────────────────────────────────
export const adjuntarMediaThunk = createAsyncThunk(
  "conversacion/adjuntarMedia",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await adjuntarMediaService(formData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al adjuntar archivos",
      );
    }
  },
);

// ── Eliminar media ──────────────────────────────────
export const eliminarMediaThunk = createAsyncThunk(
  "conversacion/eliminarMedia",
  async (mediaId, { rejectWithValue }) => {
    try {
      const response = await eliminarMediaService(mediaId);
      return { ...response, mediaId };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al eliminar el archivo",
      );
    }
  },
);

// ── Completar sesión ────────────────────────────────
export const completarSesionThunk = createAsyncThunk(
  "conversacion/completar",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await completarSesionService(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al completar la sesión",
      );
    }
  },
);

// ── Mis sesiones ────────────────────────────────────
export const getMisSesionesThunk = createAsyncThunk(
  "conversacion/misSesiones",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getMisSesionesService(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          "Error al obtener las sesiones",
      );
    }
  },
);

// ── Resumen ─────────────────────────────────────────
export const getResumenThunk = createAsyncThunk(
  "conversacion/resumen",
  async (sesionId, { rejectWithValue }) => {
    try {
      const response = await getResumenService(sesionId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el resumen",
      );
    }
  },
);
